import { Linking, View } from 'react-native';
import { useState } from 'react';

import { Text } from '@/components/Text';
import { Button } from '@/components/ui/therapist/Button';
import Card from '@/components/ui/therapist/Card';
import { constants } from '@/config/constants';
import { deleteUser, localLogoutUser } from '@/api/services/user';
import { DeleteAccountModal } from '@/components/DeleteAccountModal';

import { styles } from './styles';

export const Management: React.FC = () => {
  const [isAccountDeletionModalVisible, setIsAccountDeletionModalVisible] =
    useState(false);

  const [value, setValue] = useState('');

  const cancelAccountDeletion = () => {
    setIsAccountDeletionModalVisible(false);
    setValue('');
  };

  const confirmAccountDeletion = async () => {
    cancelAccountDeletion();

    try {
      await deleteUser();
      await localLogoutUser(true);
    } catch {
      await localLogoutUser();
    }
  };

  return (
    <Card title="Kontoverwaltung" styleBody={{ padding: 0 }}>
      <View style={[styles.itemContainer, { paddingTop: 20 }]}>
        <View style={styles.longLabelContainer}>
          <Text style={styles.label}>Kontoinformationen exportieren</Text>
          <Text>
            Laden Sie eine Datei mit Ihren bei uns gespeicherten persönlichen
            Daten herunter. Patient:innendaten sind davon ausgenommen.
          </Text>
        </View>
        <Button
          look="ghost"
          label="Exportieren"
          onPress={() =>
            Linking.openURL(`${constants.address}/settings/export`)
          }
        />
      </View>
      <View style={styles.divider}></View>
      <View style={[styles.itemContainer, { paddingBottom: 20 }]}>
        <View style={styles.longLabelContainer}>
          <Text style={styles.label}>Konto löschen</Text>
          <Text>
            Bitte beachten Sie, dass durch das Löschen Ihres Neolexon-Kontos ein
            eventuell verknüpftes Abonnement nicht automatisch gekündigt wird.
          </Text>
        </View>
        <Button
          look="danger"
          label="Konto löschen"
          onPress={() => setIsAccountDeletionModalVisible(true)}
        />
      </View>
      <DeleteAccountModal
        isVisible={isAccountDeletionModalVisible}
        onClose={cancelAccountDeletion}
        onConfirm={confirmAccountDeletion}
        value={value}
        onChangeValue={(text) => setValue(text)}
      />
    </Card>
  );
};
